// src/sectors/pilates/reports/staff/overview/ui/StaffOverviewChartsRow.jsx
import React, { useMemo } from 'react';
import Grid from '@mui/material/Grid';
import ReportsBarChart from 'examples/Charts/BarCharts/ReportsBarChart';
import ReportsLineChart from 'examples/Charts/LineCharts/ReportsLineChart';

function toLineChart(labels = [], data = [], label = 'Değer') {
  return { labels, datasets: { label, data } };
}
function toBarChart(labels = [], data = [], label = 'Adet') {
  return { labels, datasets: { label, data } };
}

const EMPTY_AGG = {
  days: [],
  trendSessions: [],
  trendAttended: [],
  trendNoShow: [],
  trendCancelled: [],
};

export function StaffOverviewChartsRow({ trainerId, loading, agg }) {
  // ✅ agg undefined gelse bile patlamasın
  const safeAgg = agg ?? EMPTY_AGG;

  // ✅ deps: agg.days değil agg?.days
  const labels = useMemo(() => (safeAgg.days || []).slice(-14), [safeAgg.days]);

  const dataSessions = useMemo(
    () => (safeAgg.trendSessions || []).slice(-14),
    [safeAgg.trendSessions]
  );
  const dataAtt = useMemo(() => (safeAgg.trendAttended || []).slice(-14), [safeAgg.trendAttended]);
  const dataNoShow = useMemo(() => (safeAgg.trendNoShow || []).slice(-14), [safeAgg.trendNoShow]);
  const dataCancelled = useMemo(
    () => (safeAgg.trendCancelled || []).slice(-14),
    [safeAgg.trendCancelled]
  );

  const chartSessions = useMemo(
    () => toBarChart(labels, dataSessions, 'Seans'),
    [labels, dataSessions]
  );
  const chartAttended = useMemo(() => toLineChart(labels, dataAtt, 'Katıldı'), [labels, dataAtt]);
  const chartNoShow = useMemo(
    () => toLineChart(labels, dataNoShow, 'Gelmedi'),
    [labels, dataNoShow]
  );
  const chartCancelled = useMemo(
    () => toLineChart(labels, dataCancelled, 'İptal'),
    [labels, dataCancelled]
  );

  const disabled = !trainerId;

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6} lg={4}>
        <ReportsBarChart
          color="info"
          title="Günlük Seans"
          description="Son 14 gün (unique seans)"
          date={disabled ? 'Eğitmen seç' : loading ? 'Yükleniyor…' : 'Günlük'}
          chart={chartSessions}
        />
      </Grid>

      <Grid item xs={12} md={6} lg={4}>
        <ReportsLineChart
          color="success"
          title="Katılım"
          description="Katılımcı bazlı ATTENDED"
          date={disabled ? 'Eğitmen seç' : loading ? 'Yükleniyor…' : 'Son 14 gün'}
          chart={chartAttended}
        />
      </Grid>
    </Grid>
  );
}
